export function isTestUrl() {
  return (
    typeof window !== 'undefined' &&
    (window.location.host.indexOf('pre.foxrenderfarm.com') !== -1 ||
      window.location.host.indexOf('localhost') !== -1)
  )
}

export const baseTaskUrl = () =>
  isTestUrl() ? 'https://task-pre.foxrenderfarm.com' : 'https://task.foxrenderfarm.com'

export const baseUrl = isTestUrl()
  ? 'https://account-pre.foxrenderfarm.com'
  : 'https://account.foxrenderfarm.com'
